import { render, staticRenderFns } from "./NotSupport.vue?vue&type=template&id=e5bea554"
import script from "./NotSupport.vue?vue&type=script&lang=ts"
export * from "./NotSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports